import React from "react";
import { Box } from "@mui/material";
import AllRequestsGrid from "./AllRequestsGrid";
import type { AllRequestRow } from "../types";

interface AllRequestsTabProps {
  rows: AllRequestRow[];
  loading?: boolean;
}

export default function AllRequestsTab({
  rows,
  loading = false,
}: AllRequestsTabProps) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      <AllRequestsGrid rows={rows} loading={loading} />
    </Box>
  );
}
